/// FOURJS_START_COPYRIGHT(D,2026)
/// Property of Four Js*
/// (c) Copyright Four Js 2026, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT
"use strict";

const DOMRectHelper = {
  /**
   * Tranform the DOMRect given in parameter to a relative transform of the reference DOMRect
   * @param refDomRect the reference domRect
   * @param {DOMRect} domRect The domRect to transform
   * @returns {DOMRect} A new DOMRect with it's coordinates equal to the one given in parameter relative to this DOMRect
   */
  viewportToLocal: function (refDomRect, domRect) {
    return new DOMRect(domRect.left - refDomRect.left, domRect.top - refDomRect.top, domRect.width, domRect.height);
  }
};

modulum("DomRectHelper", function (context, cls) {
  cls.DOMRectHelper = DOMRectHelper;
});

if (typeof module !== "undefined" && module.exports) {
  module.exports = DOMRectHelper;
}
